import Link from "next/link";
import { twMerge } from "tailwind-merge";

function Btn({
  padding = "px-8 py-2",
  color = "border-[#EC1C1C] bg-black text-[#fff]",
  shadowColor = " [box-shadow:#EC1C1C_6px_6px]",
  text,
  link,
  className = " relative mr-5 inline-block rounded-xl border   text-center font-semibold   transition-all ease-in-out duration-300 hover:border-black md:mr-6 "
}) {
  return (
    <Link
      href={link}
      className={twMerge(
        padding,
        `hover:shadow-none  `,
        color," ",
        shadowColor,
        className

      )}
    >
      {text}
    </Link>
  );
}

export default Btn;
